// @ts-nocheck
import { ToolkitListingIDParsed, isUndefined, parseToolkitListingID } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import {
  setActiveID as setActiveReferenceBarID,
  setProperties as setReferenceBarProperties,
} from '../../../redux/features/referenceBarUISlice.js';
import { useAppDispatch } from '../../../redux/hooks.js';
import { formatReferenceViewID } from '../../referenceView/index.js';
import { ReconciliationTableResults } from '../types.js';

const getParsedListingIDs = (
  results: ReconciliationTableResults,
  activePairIndex: number,
): { mls1?: string; listingID1?: string; mls2?: string; listingID2?: string } => {
  const { p1, p2 } = results[activePairIndex] ?? {};
  if (
    isUndefined(p1) ||
    isUndefined(p2) ||
    isUndefined(p1.toolkitListingID) ||
    isUndefined(p2.toolkitListingID)
  )
    return {};

  const { mls: mls1, listingID: listingID1 } = parseToolkitListingID(p1.toolkitListingID);
  const { mls: mls2, listingID: listingID2 } = parseToolkitListingID(p2.toolkitListingID);

  return { mls1, listingID1, mls2, listingID2 };
};

export const useUpdateReferenceBarPropertiesAndActiveID = (
  results: ReconciliationTableResults,
  activePairIndex: number,
) => {
  const dispatch = useAppDispatch();

  // extract just some primitives from results that we actually need to update
  // the reference bar, so we only run useEffect when these values are
  // different for Object.is. if we use objects that we recreate, they have
  // different references every time, and we keep resetting the active ref bar
  // id when we don't mean to.
  const { mls1, listingID1, mls2, listingID2 } = getParsedListingIDs(results, activePairIndex);
  useEffect(() => {
    if (
      isUndefined(mls1) ||
      isUndefined(listingID1) ||
      isUndefined(mls2) ||
      isUndefined(listingID2)
    ) {
      return;
    }

    dispatch(
      setActiveReferenceBarID(
        formatReferenceViewID({
          mls: mls1,
          listingID: listingID1,
        } as ToolkitListingIDParsed),
      ),
    );
    dispatch(
      setReferenceBarProperties([
        {
          id: formatReferenceViewID({
            mls: mls1,
            listingID: listingID1,
          } as ToolkitListingIDParsed),
          mapPinLabel: '1',
        },
        {
          id: formatReferenceViewID({
            mls: mls2,
            listingID: listingID2,
          } as ToolkitListingIDParsed),
          mapPinLabel: '2',
        },
      ]),
    );
  }, [mls1, listingID1, mls2, listingID2, setActiveReferenceBarID, setReferenceBarProperties]);
};
